// Copyright Robert Bosch GmbH. All rights reserved, also regarding any disposal, exploration, reproduction,
// editing, distribution, as well as in the event of applications for industrial property rights.
import { makeStyles } from "@material-ui/core/styles";

//@component
//reportUseStyles
const listviewUseStyles = makeStyles(() => ({
  textArea: {
    width: "100%",
    height: "100px",
    borderRadius: "5px",
  },
  header: {
    width: "97%",
    marginLeft: "1.5%",
    padding: "0.5%",
    // justifyContent: "right",
  },
  organizationTitle: {
    width: "97%",
    marginLeft: "1.5%",
    marginTop: "0.5%",
    marginBottom: "0.25%",
    fontSize: "16px",
    fontWeight: 600,
    color: "#21034F",
    fontFamily: "'Poppins' !important",
    textAlign: "left",
  },
  textareaGrid: {
    width: "100%",
    marginTop: "1%",
  },
  delete_icon: {
    height: "13px !important",
    fontSize: "3px !important",
    marginLeft: "5%",
  },
  edit_icon: {
    height: "13px !important",
    fontSize: "3px !important",
    marginLeft: "10%",
    marginBottom: "3%",
    verticalAlign: 'middle'
    //marginLeft: "15%",
  },
  sync_icon: {
    height: "18px !important",
    fontSize: "3px !important",
  },
  createuserButton: {
    color: "#fff",
    float: "right",
    border: "none",
    cursor: "pointer",
    height: "100%",
    display: "flex",
    alignItems: "center",
    padding: "9px 12px!important",
    fontSize: "11px",
    boxShadow: "0px 3px 6px #00000029 !important",
    fontFamily: "'Poppins' !important",
    fontWeight: "700",
    borderRadius: "90px",
    backgroundColor: "#03A9F3",
  },
  downloadreportButton: {
    color: "#fff",
    float: "right",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: "100%",
    padding: "9px 12px!important",
    fontSize: "11px",
    boxShadow: "0px 3px 6px #00000029 !important",
    fontFamily: "'Poppins' !important",
    fontWeight: "700",
    borderRadius: "90px",
    backgroundColor: "#67B561",
    gap: "4px",
  },
  downloadIcon: {
    width: "16px",
  },
  addIcon: {
    width: "20px",
  },
  select: {
    width: "198px !important",
    backgroundColor: "#ffffff",
    boxShadow: "0px 3px 6px #00000029 !important",
    borderRadius: "90px !important",
    height: "40px !important",
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "90px",
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      fontSize: "12px",
    },
  },
  parkingSelect: {
    width: "220px !important",
    backgroundColor: "#ffffff",
    boxShadow: "0px 3px 6px #00000029 !important",
    borderRadius: "90px !important",
    height: "40px !important",
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "90px",
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      fontSize: "12px",
    },
  },
  datePickerWrap: {
    width: "120px",
    minWidth: "120px",
    maxWidth: "120px",
  },
  dateLabel: {
    fontSize: "12px",
    color: "#21034F",
    marginBottom: "4px",
  },
  datePickerField: {
    backgroundColor: "#ffffff",
    boxShadow: "0px 3px 6px #00000029 !important",
    borderRadius: "90px !important",
    height: "40px",
    width: "120px",
    padding: "0 6px 0 10px",
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    "& .MuiFormControl-root": {
      width: "100%",
      margin: 0,
      justifyContent: "center",
    },
    "& .MuiInput-root": {
      marginTop: "0 !important",
    },
  },
  datePickerInput: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    fontSize: "11px",
    width: "100%",
    "& input": {
      padding: "0 !important",
      height: "40px",
      lineHeight: "40px",
      fontSize: "11px",
      boxSizing: "border-box",
    },
    "& .MuiInputAdornment-root": {
      height: "40px",
      maxHeight: "40px",
      marginLeft: 0,
      display: "flex",
      alignItems: "center",
    },
    "& .MuiIconButton-root": {
      padding: "4px",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
    },
  },
  paginationSelect: {
    backgroundColor: "#ffffff",
    boxShadow: "0px 3px 6px #00000029 !important",
    borderRadius: "90px !important",
    height: "48px !important",
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "90px",
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
    },
  },
  filterCheckbox: {
    "&.Mui-checked": {
      color: "#03A9F3",
    },
  },
  filterListItem: {
    backgroundColor: "white !important",
    "&:hover": {
      backgroundColor: "white !important",
    },
    "&.Mui-selected": {
      backgroundColor: "white !important",
    },
    "&.Mui-selected:hover": {
      backgroundColor: "white !important",
    },
  },
  menuPaper: {
    borderRadius: "25px !important",
  },
  filterDropdown: {
    fontFamily: "'Poppins' !important",
    fontSize: "small",
    height: "42px",
    textAlign: "left",
    boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16)",
    border: "none",
    borderRadius: "90px",
    background: "#fff",
    color: "#21034F",
    padding: "4px 10px",
    marginTop: 0,
    borderRight: "10px solid #ffffff",
    "&:focus": {
      outline: "none",
    },
  },
  deleteButton: {
    color: "#03A9F3",
    float: "right",
    width: "40%",
    border: "none",
    cursor: "pointer",
    height: "100%",
    padding: "9px 12px!important",
    fontSize: "11px",
    boxShadow: "0px 3px 6px #00000029 !important",
    fontFamily: "'Poppins' !important",
    fontWeight: "700",
    borderRadius: "90px",
    backgroundColor: "white",
  },
  searchVal: {
    color: "red",
    fontSize: "12px",
    paddingLeft: "20px",
    paddingTop: "7px",
  },
  syncButton: {
    float: "left",
    width: "60%",
    border: "none",
    cursor: "pointer",
    height: "100%",
    padding: "5px 10px!important",
    fontSize: "10px",
    boxShadow: "0px 3px 6px #00000029 !important",
    fontFamily: "'Poppins' !important",
    borderRadius: "90px",
    backgroundColor: "#fff",
  },
  labelStyle: {
    paddingTop: "12px",
  },
  liStyle: {
    display: "flex",
  },
  searchInput: {
    border: "0",
    borderRadius: "90px",
    width: "375px",
    height: "35px",
  },
  applyButtonFilter: {
    width: "60%",
    color: "#fff",
    background: "#e46767",
    borderRadius: "20px",
    padding: "5px 10px",
    fontSize: "10px",
    marginTop: "4px",
    "&:hover": {
      width: "60%",
      color: "#fff",
      background: "#e46767",
      borderRadius: "20px",
      padding: "5px 10px",
      textDecoration: "none",
      fontSize: "0.7rem",
      marginTop: "4px",
    },
    ".MuiButton-outlinedSecondary:hover": {
      border: "none",
    },
  },
  hrStyling: {
    marginTop: "20px",
  },
  liGrid: {
    height: "25px",
  },
  filter_box: {
    right: "0.0001%",
    width: "180px",
    listStyle: "none",
    backgroundColor: "#fff",
    position: "absolute",
    top: "98%",
    zIndex: 1,
    color: "#000",
    fontSize: "10px",
    paddingBottom: "20%",
    borderRadius: "3%",
    border: "1px #A9A9A9 solid",
    ".MuiButton-outlinedSecondary": {
      border: "none",
    },
    "& li": {
      display: "flex",
      marginRight: "10px",
      marginLeft: "10px",
    },
    "& label": {
      paddingTop: "12px",
    },
  },
  filter_image: {
    width: "65%",
  },
  filter_button: {
    position: "relative",
    border: "none",
    "&:hover": {
      border: "none",
    },
    "& hr": {
      marginLeft: "23.8px",
      marginRight: "23.8px",
    },
  },
  dialog: {
    zIndex: 0,
  },
  dialogActionGrid: {
    marginTop: "0.5em",
    paddingBottom: "0",
  },
  topRowGrid: {
    // marginTop: "1px"
  },
  notFoundGrid: {
    marginTop: "5%",
  },
  viewTableCell: {
    cursor: "pointer",
    textAlign: "left",
    width: "1px",
    height: "1px",
  },
  viewSpan: {
    color: "#03A9F3",
    fontWeight: "400",
    fontSize: "0.6rem",
  },
  statusRow: {
    maxWidth: "10%",
    fontSize: "0.75rem",
    fontWeight: 600,
  },
  tableRowNoImage: {
    height: "1%",
  },
  gridContainerNoImage: {
    position: "absolute",
    paddingBottom: "1%",
    marginBottom: "10px",
  },
  typographyGridNoImage: {
    marginRight: "20%",
  },
  paginationOuterGrid: {
    marginBottom: "6%",
    marginTop: "1.5%",
    width: "96%",
    marginLeft: "2%",
  },
  noList: {
    width: "190%",
    fontSize: "12px",
    marginTop: "100%",
    fontFamily: "'Poppins'",
    marginLeft: "800%",
    wordBreak: "break-word",
    textAlign: "center",
    fontWeight: "500",
  },
  paginationStyle: {
    backgroundColor: "white",
    padding: "10px",
    borderRadius: "90px",
    paddingLeft: "15px",
    boxShadow: "0px 3px 6px #00000029 !important",
  },
  pageTextGrid: {
    marginTop: "6%",
    marginRight: "20px",
  },
  tableCell: {
    fontFamily: "'Poppins' !important",
    fontSize: "12px",
    wordBreak: "break-word",
    fontWeight: "500",
    padding: "1%",
  },
  editCross: {
    visibility: "hidden",
  },
  input_cross: {
    // marginLeft:"1em"
  },
  topRowGridParent: {
    height: "50px",
    marginTop: "1%",
    marginBottom: "0.5%",
  },
  selectNavcards: {
    width: "30%",
    height: "80%",
    textAlign: "center",
    boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16)",
    marginRight: "5%",
    border: "none",
    borderRadius: "6px",
    background: "#ffffff",
    padding: "0 1px",
    paddingRight: "2%",
    marginTop: "2%",
  },
  aboveRowsGrid: {
    height: "40px",
  },
  aboveTableGrid: {},
  rowsLabel: {
    fontSize: "0.7rem",
    marginRight: "3%",
    fontWeight: "bold",
  },
  dropdownNumber: {
    border: "none",
    color: "#a2a2a2",
    outline: "none",
    marginTop: "5%",
  },
  root: {
    "& .Mui-selected": {
      backgroundColor: "#e46a76 !important",
      color: "#ffffff",
      fontWeight: "900",
    },
    "& .MuiPaginationItem-root": {
      fontFamily: "'Poppins' !important",
      fontSize: "14px",
    },
  },
  dialogSubHeader: {
    fontFamily: "'Poppins' !important",
    fontSize: "12px !important",
    marginBottom: "0.5vw",
  },
  dialogSubHeaderError: {
    fontFamily: "'Poppins' !important",
    fontSize: "12px",
    letterSpacing: "0.5px",
    color: "#F30626",
  },
  dialogSubTitle: {
    fontFamily: "'Poppins' !important",
    fontSize: "12px",
    letterSpacing: "1px",
  },
  dialogAddress: {
    fontSize: "10px",
    fontFamily: "'Poppins' !important",
    marginBottom: "0.5vw",
    marginLeft: "2.5vw",
    marginTop: "-0.3vw",
  },
  dialogSubTextFail: {
    fontWeight: "bold",
    fontFamily: "'Poppins' !important",
    fontSize: "14px",
    letterSpacing: "1px",
    color: "#F30626",
  },
  dialogSubTextPass: {
    fontWeight: "bold",
    fontFamily: "'Poppins' !important",
    fontSize: "14px",
    letterSpacing: "1px",
    color: "#67B561",
  },
  dialogCloseIcon: {
    cursor: "pointer",
    fontSize: "12px",
  },
  dialogConfirm: {
    fontFamily: "'Poppins' !important",
    borderRadius: "90px",
    cursor: "pointer",
    border: "none",
    fontSize: "10px",
    fontWeight: "900",
    color: "#fff",
    backgroundColor: "#03A9F3",
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);",
    minWidth: "64px",
    boxSizing: "border-box",
    lineHeight: "1.75",
    letterSpacing: "1px",
    padding: "9px 27px",
    textDecoration: "none",
    verticalAlign: "middle",
  },
  dialogCancel: {
    fontFamily: "'Poppins' !important",
    borderRadius: "90px",
    cursor: "pointer",
    border: "none",
    fontSize: "10px",
    fontWeight: "900",
    color: "#fff",
    backgroundColor: "#707070",
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);",
    minWidth: "64px",
    boxSizing: "border-box",
    lineHeight: "1.75",
    letterSpacing: "1px",
    padding: "9px 27px",
    textDecoration: "none",
    verticalAlign: "middle",
    marginRight: "20px",
  },
  dialogCancelGrid: {
    textAlignLast: "right",
  },
  dialogHeader: {
    fontFamily: "'Poppins' !important",
    fontSize: "14px",
    letterSpacing: "0.5px",
    fontWeight: 900,
  },
  input: {
    width: "100%",
    borderRadius: "20px",
    border: "none",
    outline: "none",
    padding: "10px",
    backgroundColor: "lightgrey",
  },
  iconButton: {
    padding: 5,
    color: "black",
    marginRight: "0.2%",
  },
  tableGrid: {
    marginTop: "1%",
    width: "96%",
    maxHeight: "30%",
    marginLeft: "2%",
    // boxShadow:'0px 3px 6px #00000029 !important',
  },

  table: {
    // minWidth: 650,
  },
  container: {
    display: "flex",
    flexWrap: "nowrap",
  },
  thData: {
    fontFamily: "'Poppins' !important",
    fontWeight: "700",
    fontSize: "12px",
    padding: "1%",
    backgroundColor: "rgba(226, 220, 242, 0.38)",
    height: "70px",
    wordWrap: "break-word",
    letterSpacing: "0.6px",
  },
  thheadDataSyncCall: {
    fontFamily: "'Poppins' !important",
    fontWeight: "700",
    fontSize: "12px",
    padding: "0%",
    backgroundColor: "rgba(226, 220, 242, 0.38)",
    height: "70px",
    wordWrap: "break-word",
    letterSpacing: "0.6px",
  },
  thDataSyncCall: {
    padding: "0% !important",
  },
  paper: {
    boxShadow: "0px 3px 6px #00000029 !important",
  },
  viewButton: {
    color: "#03a9f3",
    fontSize: "0.75rem",
    textDecoration: "underline",
    textTransform: "none",
    textAlign: "left",
  },
  reSyncContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: 'flex-end',
    gap: "8px"
  },
  resyncButton: {
    padding: '0 !important'
  }
}));

export default listviewUseStyles;
